import { render, staticRenderFns } from "./chatAllSystem.vue?vue&type=template&id=efe02128"
import script from "./chatAllSystem.vue?vue&type=script&lang=js"
export * from "./chatAllSystem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports